import axios from 'axios';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../providers/auth_provider';
import { Editor } from '@tinymce/tinymce-react';
import { htmlContent } from '../../utils/email-template';

export default function AddTemplate({ fetchTemplates }) {
    const { token } = useAuth();
    const [formData, setFormData] = useState({
        template_name: '',
        message: '', // Reset to the image
        user_accessible: false,
        title: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle rich text editor changes separately
    const handleEditorChange = (content) => {
        setFormData({ ...formData, message: content });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/template`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                }
            });
            fetchTemplates();
            toast.success('Template created successfully!');
            document.getElementById('closeModal').click();
            document.getElementById('closeCanvas').click();
            setFormData({
                template_name: '',
                message: '<p><img src="https://admin.enervybe.net/assets/img/logo.png" /></p>', // Reset to the image
                user_accessible: false,
                title: '',
            });
        } catch (error) {
            console.error('Error creating template:', error);
            toast.error(error?.response?.data?.message || 'An error occurred while creating the template');
        }
    };


    const editorConfig = {
        height: 400,
        menubar: true,
        plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'help', 'wordcount'
        ],
        toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | table | help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
    };


    return (
        <div
            className="offcanvas offcanvas-end width-50"
            tabIndex={-1}
            id="addNewTemplate"
            aria-labelledby="offcanvasAddTemplateLabel"
        >
            <div className="offcanvas-header border-bottom">
                <h5 id="offcanvasAddTemplateLabel" className="offcanvas-title">
                    Add Template
                </h5>
                <button
                    id="closeCanvas"
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                />
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 h-100">
                <form
                    className="add-new-template pt-0"
                    id="addNewTemplateForm"
                    onSubmit={handleSubmit}
                >

                    {/* Template Name */}
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="template-name"
                            placeholder="Enter template name"
                            name="template_name"
                            value={formData.template_name}
                            onChange={handleInputChange}
                            aria-label="Template Name"
                        />
                        <label htmlFor="template-name">Template Name</label>
                    </div>

                    {/* Title */}
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="template-title"
                            placeholder="Enter subject"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            aria-label="Subject"
                        />
                        <label htmlFor="template-title">Subject</label>
                    </div>

                    {/* User Accessible */}
                    <div className="form-check my-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="user-accessible"
                            name="user_accessible"
                            checked={formData.user_accessible}
                            onChange={(e) => setFormData({ ...formData, user_accessible: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="user-accessible">
                            Affiliate Accessible
                        </label>
                    </div>


                    {/* Rich Text Editor */}
                    <div className="mb-3">
                        <label className="form-label">Message</label>
                        <Editor
                            apiKey='9rfldgcdc9dmma091ep27vm5qlyb0n4qgm80qm8kelo9s860'
                            initialValue={htmlContent}
                            value={formData.message}
                            onEditorChange={handleEditorChange}
                            init={editorConfig}
                        />
                    </div>

                    <hr />
                    <button
                        type="submit"
                        className="btn btn-success me-sm-3 me-1 data-submit mt-5"
                    >
                        Submit
                    </button>
                    <button
                        id="closeModal"
                        type="reset"
                        className="btn btn-outline-secondary mt-5"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    );
}